/**
 * Custom smooth scroll with cubic-bezier easing for butter-smooth navigation.
 * Uses requestAnimationFrame for jank-free 60fps animation.
 */

// Cubic bezier easing: ease-in-out (0.42, 0, 0.58, 1)
function easeInOutCubic(t: number): number {
  return t < 0.5
    ? 4 * t * t * t
    : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

let currentAnimation: number | null = null;

export function smoothScrollTo(targetY: number, duration: number = 700): void {
  // Cancel any ongoing scroll animation
  if (currentAnimation !== null) {
    cancelAnimationFrame(currentAnimation);
    currentAnimation = null;
  }

  const startY = window.scrollY;
  const distance = targetY - startY;

  // If distance is negligible, skip animation
  if (Math.abs(distance) < 1) return;

  const startTime = performance.now();

  function step(currentTime: number) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easeInOutCubic(progress);

    window.scrollTo(0, startY + distance * easedProgress);

    if (progress < 1) {
      currentAnimation = requestAnimationFrame(step);
    } else {
      currentAnimation = null;
    }
  }

  currentAnimation = requestAnimationFrame(step);
}
